import VerticalDirectionEnum from '@models/enums/VerticalDirectionEnum';

export const easeInOut = {
  transition: { type: 'easeinout', duration: 0.25 },
};

export const scrollableMediaSlideContentAnimationVariants = {
  initial: (scrollDirection: VerticalDirectionEnum) => ({
    y: scrollDirection === VerticalDirectionEnum.Down ? 150 : -150,
    opacity: 0,
  }),
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      ease: [0.0, 0.0, 0.2, 1] as const,
      duration: 0.8,
    },
  },
  exit: (scrollDirection: VerticalDirectionEnum) => ({
    y: scrollDirection === VerticalDirectionEnum.Down ? -150 : 150,
    opacity: 0,
    transition: {
      ease: [0.0, 0.0, 0.2, 1] as const,
      duration: 0.6,
    },
  }),
};

export const scrollableMediaDelayedSlideContentAnimationVariants = {
  ...scrollableMediaSlideContentAnimationVariants,
  visible: {
    ...scrollableMediaSlideContentAnimationVariants.visible,
    transition: {
      ...scrollableMediaSlideContentAnimationVariants.visible.transition,
      delay: 0.2,
    },
  },
};

export const scrollableMediaSlideMediaAnimationVariants = {
  initial: { opacity: 0, scale: 1.05 },
  animate: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.8, ease: [0.4, 0, 0.2, 1] as const },
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: { duration: 0.6, ease: [0.4, 0, 0.2, 1] as const },
  },
};
